"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTreeChairCreation = void 0;
var _tree = require("./tree");
var getTreeChairCreation = exports.getTreeChairCreation = function getTreeChairCreation() {
  var pricingVersion = (0, _tree.getPricingVersion)();
  return {
    question: 'Pour quel type d’assise souhaitez-vous faire une housse ?',
    answers: [{
      clothSlug: 'crea_chai',
      name: 'Housse de chaise',
      slug: 'SMALL',
      label: 'Chaise sans accoudoirs',
      id: "".concat(pricingVersion, ".crea_chai-acco-1"),
      image: 'https://res.cloudinary.com/tilli/image/upload/v1709561544/tilli-core/sans_accoudoirs.jpg',
      questions: [{
        slug: 'lining',
        label: 'Quelle longueur de housse souhaitez-vous ?',
        answers: [{
          slug: 'withoutLining',
          label: 'Ajusté',
          image: 'https://res.cloudinary.com/tilli/image/upload/v1709561537/tilli-core/jupe_ajuste%CC%81e.jpg'
        }, {
          slug: 'withLining',
          label: 'Avec jupe longue',
          id: "".concat(pricingVersion, ".crea_chai-supp-1"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1709561538/tilli-core/jupe_longue.jpg'
        }, {
          slug: 'seeInRDV',
          label: 'Voir en RDV'
        }]
      }, {
        slug: 'closing',
        label: 'Quel système d’attache souhaitez-vous ?',
        answers: [{
          slug: 'withScratch',
          label: 'Scratch',
          id: "".concat(pricingVersion, ".crea_chai-supp-26")
        }, {
          slug: 'withKnots',
          label: 'Noeuds',
          id: "".concat(pricingVersion, ".crea_chai-supp-2")
        }, {
          slug: 'withElastics',
          label: 'Élastiques',
          id: "".concat(pricingVersion, ".crea_chai-supp-6")
        }, {
          slug: 'undefined',
          label: 'Voir en RDV'
        }]
      }, {
        slug: 'range',
        label: 'Combien de housse identique souhaitez-vous faire ?'
      }]
    }, {
      clothSlug: 'crea_chai',
      name: 'Housse de chaise',
      slug: 'BIG',
      label: 'Chaise avec accoudoirs',
      id: "".concat(pricingVersion, ".crea_chai-acco-2"),
      image: 'https://res.cloudinary.com/tilli/image/upload/v1709561535/tilli-core/avec_accoudoirs.jpg',
      questions: [{
        slug: 'lining',
        label: 'Quelle longueur de housse souhaitez-vous ?',
        answers: [{
          slug: 'withoutLining',
          label: 'Ajusté',
          image: 'https://res.cloudinary.com/tilli/image/upload/v1709561536/tilli-core/jupe_ajuste%CC%81e_accoudoirs.jpg'
        }, {
          slug: 'withLining',
          label: 'Avec jupe longue',
          id: "".concat(pricingVersion, ".crea_chai-supp-1"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1709561536/tilli-core/jupe_longue_accoudoirs.jpg'
        }, {
          slug: 'seeInRDV',
          label: 'Voir en RDV'
        }]
      }, {
        slug: 'closing',
        label: 'Quel système d’attache souhaitez-vous ?',
        answers: [{
          slug: 'withScratch',
          label: 'Scratch',
          id: "".concat(pricingVersion, ".crea_chai-supp-26")
        }, {
          slug: 'withKnots',
          label: 'Noeuds',
          id: "".concat(pricingVersion, ".crea_chai-supp-2")
        }, {
          slug: 'withElastics',
          label: 'Élastiques',
          id: "".concat(pricingVersion, ".crea_chai-supp-6")
        }, {
          slug: 'undefined',
          label: 'Voir en RDV'
        }]
      }, {
        slug: 'range',
        label: 'Combien de housse identique souhaitez-vous faire ?'
      }]
    }, {
      clothSlug: 'crea_stoo',
      name: 'Housse de tabouret/pouf',
      slug: 'SMALL',
      label: 'Tabouret/Pouf',
      id: "".concat(pricingVersion, ".crea_stoo-dime-1"),
      image: 'https://res.cloudinary.com/tilli/image/upload/v1709561523/tilli-core/stool.jpg',
      questions: [{
        slug: 'size',
        label: 'Quelle est la taille de votre tabouret ?',
        answers: [{
          slug: 'SMALL',
          label: '+ grand côté inférieur à 50cm',
          id: "".concat(pricingVersion, ".crea_stoo-dime-1")
        }, {
          slug: 'BIG',
          label: '+ grand côté supérieur à 50cm',
          id: "".concat(pricingVersion, ".crea_stoo-dime-2")
        }]
      }, {
        slug: 'closing',
        label: 'Quel système d’attache souhaitez-vous ?',
        answers: [{
          slug: 'withScratch',
          label: 'Scratch',
          id: "".concat(pricingVersion, ".crea_stoo-supp-25")
        }, {
          slug: 'withKnots',
          label: 'Noeuds',
          id: "".concat(pricingVersion, ".crea_stoo-supp-1")
        }, {
          slug: 'withElastics',
          label: 'Élastiques',
          id: "".concat(pricingVersion, ".crea_stoo-supp-5")
        }, {
          slug: 'undefined',
          label: 'Voir en RDV'
        }]
      }]
    }]
  };
};